import { BaseControl } from "../base-control";

class ReportControlCtrl extends BaseControl {
  reportRecs = [];
  constructor(BaseControlService, TBService, RecordService, SchemaService, $scope, $element, $compile, $sce, TemplateService, ReportGroupService, FEService) {
    'ngInject';
    super(BaseControlService, $scope);
    this.rs = RecordService;
    this.ss = SchemaService;
    this.tb = TBService;
    this.ts = TemplateService;
    this.gs = ReportGroupService;
    this.fe = FEService;
    this.$scope = $scope;
    this.$sce = $sce;
    this.$element = $element;
    this.$compile = $compile;
    this.reportTokenIds = {};
    this.reportTokenClasses = {};
    this.reportTokenStyles = {};
    this.reportLoaded = false;
    this.editActivated = false;
    this.groups = null;
    this.reportRecReferenceIds = {};
    this.totalsFields = [];
    this.addingRows = false;
    this.reportValidatorModel = '';
  }

  get canInsertRecords() {
    return !!this.token.options?.insertRecords;
  }

  get nonEmptyRecordCount() {
    const rowHasFieldValues = (rec) => {
      return (this.usedReportFieldIds || []).some(fid =>
        this.rs.valIfDefined(rec[fid]?.value) !== undefined
      );
    };
    return (this.reportRecs || []).filter(r =>
      r._dataItem && (!r._added || rowHasFieldValues(r))
    ).length;
  }

  get isEmpty() {
    if (this.canInsertRecords) return !this.nonEmptyRecordCount;
    return super.isEmpty;
  }

  get isEditable() {
    const refId = this.token.referenceId;
    const inUpdateMode = this.ts.template?.signTemplate === true
      ? this.rcs.isRefUpdate(refId)
      : this.isUpdate;
    return inUpdateMode && this.token.options?.editReport && this.reportRecs?.length;
  }

  async initializeControlData() {
    if (this.template?.type != 'dynamic') return;

    this.reportTableId = this.token.control.query.from;

    this.loadReportSettings(); // Get report settings: fields used
    const allRecs = await this.loadReportRecords(); // Query report records
    const filteredRecs = this.postFilter(allRecs); // Filter report records
    this.prepareRecords(filteredRecs); // Prepare record array (including groups)
    this.isEditable && this.addTempReportReferences(); // Add initial temp references (when updating editable report)
    await this.compileResponse(this.isEditable); // Compile report html
    await super.initializeControlData();
    this.addWatchers();
    if (this.canInsertRecords) this.onReportRecsChanged();
  }

  addWatchers() {
    this.$scope.$watch('$ctrl.reportLoaded', newVal => newVal && this.handleCustomButtons());
  }

  setEnabled() {
    if (!this.canInsertRecords) return super.setEnabled();
    const sessionEditable = this.ts.template?.signTemplate === true
      ? this.rcs.isRefEditable(this.token.referenceId)
      : this.as.isEditableAction;
    this.enabled = this.isNotAForm || (this.visible && sessionEditable && this.bs.evalEnabledBehavior(this.token.id));
  }

  setRequired() {
    if (!this.canInsertRecords) return super.setRequired();
    const behaviorRequired = this.visible && this.enabled && this.bs.evalRequiredBehavior(this.token.id);
    this.required = behaviorRequired && !this.nonEmptyRecordCount;
  }

  onReportRecsChanged() {
    this.updateBehaviorsStatus();
    this.es.dispatchEvent(this.es.actions.MODEL_UPDATED, null);
  }

  subscribeEditEvents() {
    if (this._subscribedEditEvents) return;
    this.es.subscribeEvent(
      this.es.actions.FIELD_UPDATED,
      ({token}) => {
        if (token._reportId != this.token.id) return;
        if (this.canInsertRecords) this.onReportRecsChanged();
        if (this.editActivated && this.totalsFields.includes(token.fieldId))
          this.reportFieldUpdated(token);
      },
      `FIELD_UPDATED_REPORT${this.token.id}`
    );
    this._subscribedEditEvents = true;
  }

  handleCustomButtons() {
    // Insert buttons are only visible when not printing
    const $customReportInsertButtons = $(`button.fe-action-report-insert[data-token-id='${this.token.id}']`);
    if (this.isPrint) $customReportInsertButtons.hide();
    else $customReportInsertButtons.off('click').on('click', event => this.insertReportRow(event.target));

    // Download buttons are only visible when printing
    const $customReportDownloadButtons = $(`button.fe-action-report-download`);
    if (!this.isPrint) $customReportDownloadButtons.hide();
    else $customReportDownloadButtons.off('click').on('click', event => this.es.dispatchEvent(this.es.actions.DOWNLOAD_REPORT, event));
    
    // Remove buttons are not visible when report loads (can't remove existing records, for now)
    const $customReportRemoveButtons = $("button.fe-action-report-remove");
    $customReportRemoveButtons.hide();
  }

  async insertReportRow(target) {
    if (this.addingRows) return;
    const $button = $(target);

    if (!this._fieldsValidated && !this.requiredFiedIds.every(fid => this.usedReportFieldIds.includes(fid))) {
      $button.html('REPORT HAS MISSING REQUIRED FIELDS!');
      $button.prop('disabled', true);
      $button.css("border", "2px solid red");
      this._fieldsValidated = true;
      return;
    }
    
    const btnHtml = $button.html();
    $button.html('<span class="fa fa-spin fa-spinner"></span>');
    $button.prop('disabled', true);
    this.addingRows = true;
    this.initReportEdit();
    const newRec = { 
      _class: 'report-item', 
      _dataItem: true, _initializing: true, _added: true };
    this.reportFieldIds.forEach(fId => newRec[fId] = { 
      value: null, display: this.$sce.trustAsHtml('')
    });
    this.reportRecs.push(newRec);
    this.addTempReportReference(newRec, 0, true);
    await this.compileResponse(true);
    newRec._initializing = false;
    this.addingRows = false;
    $button.html(btnHtml);
    $button.prop('disabled', false);
    this.$scope.$apply(_ => {
      this.onReportRecsChanged();
      this.$timeout(_ => $(`button.fe-action-report-remove[data-token-id='${this.token.id}']`)
        .off('click').on('click', event => this.removeReportRow($(event.target).closest('.fe-report-body'))));
    });
  }

  removeReportRow(reportBody) {
    const rec = angular.element(reportBody).scope()?.rec;
    const referenceId = rec?._referenceId;
    if (!referenceId) return;
    this.template.tokens = this.template.tokens.filter(r => r.referenceId !== referenceId);
    this.template.references = this.template.references.filter(r => r.id !== referenceId);
    this.template.relations = this.template.relations.filter(r => r.childId !== referenceId);
    this.reportRecs = this.reportRecs.filter(r => r._referenceId !== referenceId);
    this.rs.removeReportRid(referenceId);
    this.onReportRecsChanged();
  }

  reportFieldUpdated(token) {
    const groupId = token._groupId;
    const fieldId = token.fieldId;
    if (token._reportId != this.token.id || !groupId) return;

    const formatter = this.tokenFormatters[token.fieldId];
    if (!formatter) return;

    this.calcFieldSubtotal(formatter, fieldId, groupId);
    this.calcFieldTotal(formatter, fieldId);
  }

  loadReportSettings() {
    const fIds = [];
    const { query } = this.token.control;

    const tokenElements = this.$scope.$parent.inner.find(".fe-token") || [];
    tokenElements.map((_idx, te) => fIds.push(te.dataset.fieldId));
    // Note: First field id is used to insert group info
    this.firstReportFid = fIds[0];
    this.usedReportFieldIds = [...fIds];
    this.requiredFiedIds = this.ss.getTableSchemaRequiredFields(this.token.control?.reportTableSchema);

    // Get just the fIds we should query:
    fIds.push(this.PROVIDER.recordIdField);
    fIds.push(...(this.token.options?.filters?.map(f => f.fieldId) || []));
    fIds.push(...(this.token.options?.groupings?.map(f => f.groupBy) || []));
    fIds.push(...(this.token.options?.sortBy?.map(f => f.fieldId) || []));

    // Note: query.select contains all tableschema fields, but we don't need to select them all
    this.reportFieldIds = Array.from(new Set(query.select.filter(fid => fIds.includes(fid))));
  }

  async loadReportRecords() {
    const filterValue = this.model.value;
    if (!filterValue) return [];

    const templateId = this.ts.templateId;
    const tokenId = this.token.id;
    const { "data": { results } } = await this.rs.queryRecords({ type: 'reportControl', templateId, tokenId, filterValue });
    return results[0].records;
  }

  postFilter(allRecs) {
    const filters = (this.token.options?.filters || []);
    return allRecs.filter(record => {
      return !filters.some(filter => {
        const { fieldId, operator, value } = filter;
        if (!fieldId) return false; // Don't attempt to eval a broken filter.
        if (operator !== "==") throw new Error("Unsupported filter operator");
        return record[fieldId].value != value;
      });
    });
  }

  getReportField(fid) {
    return this.token.control.reportTableSchema.fields.find(rf => rf.id == fid);
  }

  fetchComparison(groupBy, sort) {
    return this.gs.compare()[this.fetchEvaluation(groupBy)][sort];
  }

  fetchEvaluation(groupBy) {
    const { fieldType } = this.getReportField(groupBy);
    switch (fieldType) {
      case "currency":
        return "numeric";
      case "float":
        return "numeric";
      case "date":
        return "date";
      default:
        return "text";
    }
  }

  fetchEvaluationFunction(groupBy) {
    return this.gs.evaluate()[this.fetchEvaluation(groupBy)];
  }

  prepareRecords(filteredRecs) {
    if (!filteredRecs?.length) return;

    let records = filteredRecs.map(r => { return {...r, _class: 'report-item', _dataItem: true }});

    const sortBy = (this.token.options?.sortBy || [])
      .filter(s => s.fieldId);

    if (sortBy.length > 0) {
      const evalFuncs = [], compareFunctions = [];

      sortBy.forEach(({ fieldId, order }) => {
        const evalFunc = this.fetchEvaluationFunction(fieldId);
        evalFuncs.push((rec) => evalFunc(rec, fieldId));
        compareFunctions.push(this.fetchComparison(fieldId, order));
      });

      records = this.gs.sortBy(records, evalFuncs, compareFunctions);
    }

    const groupings =
      (this.token.options?.groupings || [])
        .filter(g => g.groupBy)
        .map(g => { return { ...g, grouping: g.grouping || 'equal-values' } });

    const numericFields = this.usedReportFieldIds.filter(fid => this.getReportField(fid)?.fieldType == "float");
    this.currencyFields = this.usedReportFieldIds.filter(fid => this.getReportField(fid)?.fieldType == "currency");
    this.totalsFields = [...numericFields, ...this.currencyFields];

    const fieldSchemas = this.token.control.reportTableSchema.fields;
    this.tokenFormatters = {};
    this.totalsFields.forEach(fid => {
      const fieldSchema = fieldSchemas.find(f => f.id == fid);
      const formatter = this.tfs.getFormatter(fieldSchema);
      if (formatter) this.tokenFormatters[fid] = formatter;
    });

    if (groupings.length > 0) {
      // Only handle one group definition at a time for now.
      const [{ groupBy }] = groupings;
      const evalFunc = this.fetchEvaluationFunction(groupBy);
      this.groups = this.gs.groupBy(records, (rec) => evalFunc(rec, groupBy), this.totalsFields);
      records = this.gs.outputGroups(this.groups, this.firstReportFid);
    }

    this.reportRecs = records.map(rec => {
      return this.reportFieldIds.reduce((acc, field) => {
        const { value = null, display = "", _class, _dataItem, _groupId } = rec[field] || {};
        let cellDisplay = display;
        const formatter = this.tokenFormatters[field];
        if (formatter && (value !== null && value !== undefined && value !== '')) {
          const num = parseFloat(value);
          if (!Number.isNaN(num)) {
            const formattedStr = formatter.formatFloatStr(formatter.jsFloatToStr(num), '', formatter.currencySymbol || '', false);
            cellDisplay = formattedStr;
          }
        }
        return { ...acc, [field]: { value, display: this.$sce.trustAsHtml((cellDisplay != null ? cellDisplay : '').toString()), _class, _dataItem, _groupId } };
      }, { _class: rec._class, _dataItem: rec._dataItem, _groupId: rec._groupId });
    });
  }

  async compileResponse(addTempTokens) {
    this._transcluded = this._transcluded || this.$scope.$parent.inner.clone(true);
    const transcluded = this._transcluded.clone(true);

    this._reportBody = this._reportBody || transcluded.find(".fe-report-body");
    if (this._reportBody.length == 0) {
      // Vertical reports
      transcluded.attr("ng-repeat", "rec in $ctrl.reportRecs | filter:{ _initializing: '!true'}");
    } else {
      // Table reports
      this._reportBody.attr("ng-repeat", "rec in $ctrl.reportRecs | filter:{ _initializing: '!true'}");
      this._reportBody.attr("ng-class", "rec._class");
    }

    const reportTokenElements = transcluded.find(".fe-token") || [];
    if (addTempTokens) await this.addTempReportTokens(reportTokenElements);

    reportTokenElements.map((i, el) => {
      const val = this.getReportTokenHtmlTemplate(el);
      if (!el.parentElement) {
        el.innerHTML = val;
      } else {
        el.outerHTML = val;
      }
    });

    if (!this._compiled) {
      this.$element.find(".report-control").append(this.$compile(transcluded)(this.$scope));
      this._compiled = true;
    }

    this.reportLoaded = true;
    this.$scope.$apply();

    this.$timeout(() => this.dom.invokeControlsRendered(this.$element[0]));

    !this._reportAdjusted && this.$timeout(_ => {
      this._reportAdjusted = true;
      this.setReportContainerStyles();
      this.calcTotals();
      this.$scope.$apply();
      this.$timeout(_ => this.isEditable && this.initReportEdit());
    });
  }

  setReportContainerStyles() {
    $("tr.report-summary td").hide();
    $("tr.report-summary td:first-child").attr('colspan', "100%").show();
    $(".report-summary .not-report-summary").hide();
    $(".report-subtotals .not-report-subtotals").hide();
    $(".report-totals .not-report-totals").hide();
    $(".report-items .not-report-items").hide();
  }
  
  initReportEdit() {
    this.editActivated = true;
    this.subscribeEditEvents();
  }

  formatFloatValue = (formatter, obj, acc) => acc + formatter.formattedStrToFloat(obj?.value || 0);

  calcTotals() {
    if (!this.groups || !this.groups.size) return;
    this.totalsFields.forEach(fieldId => {
      const formatter = this.tokenFormatters[fieldId];
      let groupId = 0;
      this.groups.forEach(_ => this.calcFieldSubtotal(formatter, fieldId, ++groupId));
      this.calcFieldTotal(formatter, fieldId);
    });
  }

  calcFieldSubtotal(formatter, fieldId, groupId) {
    const subtotal = this.reportRecs.filter(r => r._dataItem && r._groupId == groupId)
      .reduce((subtotal, r) => this.formatFloatValue(formatter, r[fieldId], subtotal), 0);
    const subtotalStr = formatter.formatFloatStr(formatter.jsFloatToStr(subtotal), '', formatter.currencySymbol, true);
    $(`.token-id-${this.token.id} .report-subtotals.report-group-${groupId} .report-fid-${fieldId}`).html(subtotalStr.toString());
  }

  calcFieldTotal(formatter, fieldId) {
    const total = this.reportRecs.filter(r => r._dataItem)
      .reduce((total, r) => this.formatFloatValue(formatter, r[fieldId], total), 0);
    const totalStr = formatter.formatFloatStr(formatter.jsFloatToStr(total), '', formatter.currencySymbol, true);
    $(`.token-id-${this.token.id} .report-totals .report-fid-${fieldId}`).html(totalStr.toString());
  }

  getReportTokenHtmlTemplate(el) {
    const { fieldId } = el.dataset;

    return `
      <span 
        ng-if="!rec._dataItem || (!$ctrl.isEditable && !rec._added)"
        class="report-fid-${fieldId}"
        ng-bind-html="rec[${fieldId}].display" 
        style="${el.style.cssText}"></span>
      <fe-control 
        ng-if="rec._dataItem && ($ctrl.isEditable || rec._added)"
        class="token-container preview-input report-fid-${fieldId} fe-token" 
        ng-class="$ctrl.reportTokenClasses[${fieldId}]"
        ng-style="$ctrl.reportTokenStyles[$ctrl.reportTokenIds[$index][${fieldId}]]"
        token-id="::$ctrl.reportTokenIds[$index][${fieldId}]" 
        parent-report-token-id="'${this.token.id}'"
        model="rec[${fieldId}]"></fe-control>`;
  }

  addTempReportReferences() {
    this.reportRecs.forEach((rec, index) => this.addTempReportReference(rec, index));
  }

  addTempReportReference(rec, index, added=false) {
    if (!rec._dataItem) return;
    const tempRef = this.createTempReference(this.reportTableId, this.token.control.reportTableSchema, added);
    this.template.references.push(tempRef);
    this.rs.addReportRid(tempRef.id, rec[this.PROVIDER.recordIdField].value, rec);
    rec._referenceId = tempRef.id;
    this.reportRecReferenceIds[tempRef.id] = index;
    this.addTempReportRelation(rec);
  }

  addTempReportRelation(rec) {
    if (!rec._dataItem) return;
    const fieldId = this.token.control.targetFieldId;
    const parentId = this.token.referenceId;
    const childId = rec._referenceId;
    const hasRelation = (this.template.relations || []).some(
      (r) => r.childId === childId && r.parentId === parentId
    );
    if (!hasRelation) {
      this.template.relations.push(this.createTempRelation(parentId, childId, fieldId));
    }

    if (this.isSubmit) return;

    const filterValue = this.model.value;
    const refRec = { value: filterValue, display: null };
    rec[childId] = refRec;
    this.rs.updatedRecords = { ...this.rs.updatedRecords, ...{ [childId]: { [fieldId]: refRec }}};
  }

  async addTempReportTokens(tokenElements) {
    let reportTokens = {};

    const firstReportRecWithRef = this.reportRecs.find(r => this.addingRows ? r._initializing : (r._dataItem && r._referenceId));
    if (!firstReportRecWithRef) return;
    const firstTempRefId = firstReportRecWithRef._referenceId;
    const firstTempRef = this.template.references.find(r => r.id == firstTempRefId);
    const tokenSettings = [];

    reportTokens = {[firstTempRefId]: []};
    this.reportTokenIds[0] = this.reportTokenIds[0] || {};
    const baseTokenStyles = [];
    
    tokenElements.map((_i, el) => {
      const { fieldId, props } = el.dataset;
      const jsonProps = this.fe.safeParseJSON(props);
      
      tokenSettings.push({fieldId, props: jsonProps});
      const ref = firstTempRef;
      const token = this.createTempToken(fieldId, ref.id, firstReportRecWithRef, jsonProps);
      reportTokens[firstTempRefId].push(token);
      baseTokenStyles.push(this.tb.getCssObj(el.attributes.style?.value.replace(/["]+/g, "'") || ''));
    });

    if (!this._tokenControls && reportTokens[firstTempRefId].length) {
      const { data: { controls } } = await this.ts.fetchControls(reportTokens[firstTempRefId]);
      this._tokenControls = controls;
    }

    this.reportRecs.forEach((rec, recIndex) => {
      if (!rec._dataItem || (this.addingRows && !rec._initializing)) return;
      const refId = rec._referenceId;
      reportTokens[refId] = [];
      this.reportTokenIds[recIndex] = {};
      tokenSettings.forEach((t, i) => {
        const fid = t.fieldId;
        const token = this.createTempToken(fid, refId, rec, t.props);
        token.control = this._tokenControls[i];
        reportTokens[refId].push(token);
        this.reportTokenIds[recIndex][fid] = token.id;
        const defaultCss = this.tb.getCssObj(token.control.defaultCss || '');
        this.reportTokenStyles[token.id] = this.tb.getCssObj(this.tb.getDynamicTokenLayout(this.template.layout, token, {...defaultCss, ...baseTokenStyles[i]}));
        if (recIndex == 0) this.reportTokenClasses[fid] = `fe-control-${token.control.type}`;
      });
    });
    
    this.template.tokens.push(...Object.values(reportTokens).flat());
  }

  createTempToken(fieldId, referenceId, rec, props) {
    return this.ts.initializeNewObject({
      '_temp': true,
      '_reportId': this.token.id,
      '_groupId': rec._groupId,
      'pageId': null,
      'templateId': this.template.id,
      'referenceId': referenceId,
      'fieldId': fieldId,
      'layout': '',
      'options': {},
      'fieldSchema': this.getReportField(fieldId),
      ...props
    });
  }

  createTempReference(tableId, tableSchema, isNew=false) {
    return this.ts.initializeNewObject({
      "_temp": true,
      "_new": isNew,
      "templateId": this.template.id,
      "name": `TempTable`,
      "tableId": tableId,
      "realm": this.template.realm,
      "provider": this.template.provider,
      tableSchema
    });
  }

  createTempRelation(parentId, childId, fieldId) {
    return this.ts.initializeNewObject({
      "_temp": true,
      "templateId": this.template.id,
      "childId": childId,
      "fieldId": fieldId,
      "parentId": parentId,
      "realm": this.template.realm,
      "provider": this.template.provider
    });
  }

}

export default {
  bindings: {
    token: "<",
    model: "=",
    tabNumber: "<",
    inner: "<"
  },
  templateUrl: "fe-control/controls/report-control/report-control.component.html",
  controller: ReportControlCtrl
};